import { Button, Modal, message } from 'antd'
import { MARK_SERIES_AS_PLAYED } from 'graphql/mutation/markSeriesAsPlayed'

import { useMutation } from '@apollo/client'

type Props = {
  seriesId: string
  count?: number
  onMarkedAsRead?: () => void
}

function MarkSeriesReadButton({ seriesId, count, onMarkedAsRead }: Props) {
  const [markSeriesAsPlayed, { loading }] = useMutation<{ markSeriesAsPlayed: boolean }, { seriesId: string }>(
    MARK_SERIES_AS_PLAYED
  )

  const onClick = () => {
    Modal.confirm({
      title: 'Mark all as read?',
      content: count ? `Mark all ${count} shiurim in this series as read?` : 'Mark all shiurim in this series as read?',
      okText: 'Mark all as read',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await markSeriesAsPlayed({ variables: { seriesId } })
          message.success('Series marked as read')
          onMarkedAsRead?.()
        } catch (e) {
          message.error('Could not mark series as read')
        }
      },
    })
  }

  return (
    <Button type="link" loading={loading} onClick={onClick} style={{ paddingLeft: 0 }}>
      Mark all as read
    </Button>
  )
}

export default MarkSeriesReadButton
